"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withToast = exports.useToast = exports.ToastProvider = void 0;
var React = __importStar(require("react"));
var react_1 = require("react");
var material_1 = require("@mui/material");
var createStyles_1 = __importDefault(require("@mui/styles/createStyles"));
var makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
var color_1 = require("../core/style/color");
var noop = function (_) { };
var ToastContext = React.createContext({
    toastError: noop,
    toastSuccess: noop,
    toastWarning: noop,
    toastInfo: noop,
    toastLoading: noop,
});
var useStyles = (0, makeStyles_1.default)(function (t) { return (0, createStyles_1.default)({
    iError: {
        color: t.palette.error.main,
    },
    iSuccess: {
        color: color_1.colorSuccess,
    },
    iWarning: {
        color: color_1.colorWarning,
    },
    iInfo: {
        color: color_1.colorInfo,
    },
    label: {
        marginLeft: t.spacing(2),
    }
}); });
var ToastProvider = function (_a) {
    var children = _a.children, _b = _a.vertical, vertical = _b === void 0 ? 'bottom' : _b, _c = _a.horizontal, horizontal = _c === void 0 ? 'left' : _c;
    var classes = useStyles();
    var _d = (0, react_1.useState)(undefined), type = _d[0], setType = _d[1];
    var _e = (0, react_1.useState)(undefined), message = _e[0], setMessage = _e[1];
    var _f = (0, react_1.useState)(false), open = _f[0], setOpen = _f[1];
    var pop = function (type) { return function (message) {
        setOpen(true);
        setType(type);
        setMessage(message);
    }; };
    var renderIcon = function (type) {
        switch (type) {
            case 'error':
                return React.createElement(material_1.Icon, { className: classes.iError }, "error");
            case 'success':
                return React.createElement(material_1.Icon, { className: classes.iSuccess }, "check_circle");
            case 'warning':
                return React.createElement(material_1.Icon, { className: classes.iWarning }, "warning");
            case 'info':
                return React.createElement(material_1.Icon, { className: classes.iInfo }, "info");
            case 'loading':
                return React.createElement(material_1.CircularProgress, { size: 24, thickness: 5 });
            default:
                return React.createElement(React.Fragment, null);
        }
    };
    var close = function () { return setOpen(false); };
    return (React.createElement(ToastContext.Provider, { value: {
            toastError: pop('error'),
            toastSuccess: pop('success'),
            toastWarning: pop('warning'),
            toastInfo: pop('info'),
            toastLoading: pop('loading'),
        } },
        children,
        React.createElement(material_1.Snackbar, { anchorOrigin: { vertical: vertical, horizontal: horizontal }, open: open, autoHideDuration: type === 'error' ? 1000000 : 6000, onClose: close, message: React.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
                renderIcon(type),
                React.createElement("span", { className: classes.label }, message)), action: React.createElement(material_1.IconButton, { onClick: close, color: "inherit", size: "large" },
                React.createElement(material_1.Icon, null, "close")) })));
};
exports.ToastProvider = ToastProvider;
var useToast = function () { return (0, react_1.useContext)(ToastContext); };
exports.useToast = useToast;
var withToast = function (Component) { return function (props) { return (React.createElement(ToastContext.Consumer, null, function (other) { return React.createElement(Component, __assign({}, props, other)); })); }; };
exports.withToast = withToast;
//# sourceMappingURL=Toast.js.map